import MenuPage from './MenuPage';
export default MenuPage;
